<template>
  <KartePlannerCommentMonthlyAmountCounter
    v-if="props.amount"
    :usage="props.amount.usage"
    :upperLimit="props.amount.upperLimit ?? undefined"
  />
</template>

<script setup lang="ts">
import KartePlannerCommentMonthlyAmountCounter from './KartePlannerCommentMonthlyAmountCounter.vue'
import type { V2023_1KartePlannerCommentMonthlyAmountFragment } from './KartePlannerCommentMonthlyAmountV20231.generated'

const props = defineProps<{
  amount: Maybe<V2023_1KartePlannerCommentMonthlyAmountFragment>
}>()
</script>
